module.exports = __webpack_public_path__ + "img/Wp_2017.64d4bb40.png";